/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".grid-container[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr 1fr 1fr;grid-template-rows:auto;gap:1rem;margin-right:10%;margin-left:10%}.grid-item[_ngcontent-%COMP%]{width:18.75rem;height:9.375rem;background-color:#fff;border:.063rem solid #005984;border-radius:.313rem;cursor:pointer;margin-top:5%}.grid-item[_ngcontent-%COMP%]:hover{box-shadow:0 .125rem .25rem #4c4c4c66;background:#f3fbfd}"];
export { styles as styles };
